window.VH = window.VH === undefined ? {} : window.VH;
VH.PageSizer = {
    selector : false,

    init : function init(selectorId, cookieName) {
        let _t = VH.Sidebar;
        _t.selector = $("#" + selectorId);
        _t.selector.on('change', function () {
            let val = $(this).val();
            Cookies.set(cookieName, val);
            document.location.reload();
            //console.log([selectorId, cookieName, val]);
        });
    }
};
